// Mirrors backend/src/pdfTemplates/designA/designAFormatters.js's
// formatPercent exactly. Quantity/discount%/tax% fields come straight off
// DECIMAL-typed DB columns, which the API returns as strings carrying the
// column's full declared scale (e.g. "7.0000000", "1.0000000000000").
// Displaying those raw, or summing them with += without converting to a
// number first (silently falls back to string concatenation, e.g.
// 0 += "1.0000000000000" -> "01.000..."), is exactly the bug this fixes.
// Matches the legacy frontend's own exact convention (ServiceVoucherBody.jsx
// etc.): fix to 2dp, then drop a bare ".00" so whole numbers print clean.
export function formatPercent(v) {
  return Number(v || 0).toFixed(2).replace(/\.00$/, "");
}

// A row's discount can be entered either as a % or as a flat amount
// (sales_details.discount_mode etc., always "percent" unless the user
// explicitly switched it) -- item_discount_per is always a back-computed
// percentage either way, so recomputing the discount from it when the
// mode is actually "amount" risks a rounding mismatch against the exact
// flat amount the user entered. Always resolve from the authoritative
// field for whichever mode this row is actually in.
export function resolveItemDiscountAmount(d, lineBase) {
  if (d?.discount_mode === "amount") return Number(d.item_discount || 0);
  return (Number(d?.item_discount_per || 0) / 100) * lineBase;
}

// What the Disc column prints for one row. The column header is mode-
// neutral ("Disc", not "Disc %") since a single invoice can have some
// rows in % mode and others in flat-amount mode -- each row's own value
// needs to say which it is: a % gets an explicit "%" suffix, a flat
// amount prints as a plain formatted number (decimals, no "%"), which
// already reads unambiguously different from a percentage.
export function formatItemDiscountCell(d, numberFormatFn) {
  if (d?.discount_mode === "amount") return numberFormatFn(Number(d.item_discount || 0));
  return `${formatPercent(d?.item_discount_per)}%`;
}
